import { render, staticRenderFns } from "./AppSaveOnLeave.vue?vue&type=template&id=2ed15c30&"
import script from "./AppSaveOnLeave.vue?vue&type=script&lang=js&"
export * from "./AppSaveOnLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports